import { createQueryHook } from "@/utils/hooks";
import { getResidentialUnitsByProjectId } from "../residential-units";

// Only enable when projectId is defined
export const useResidentialUnitsByProjectId = createQueryHook(getResidentialUnitsByProjectId);